import { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../home/components/Footer';

export default function ProfilePage() {
  const [isNavFixed, setIsNavFixed] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsNavFixed(true);
    } else {
      setIsNavFixed(false);
    }
  };

  useState(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isNavFixed ? 'bg-white shadow-md' : 'bg-white/80 backdrop-blur-sm'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-800" style={{ fontFamily: "'Klee One', cursive" }}>
            こころケア
          </Link>
          
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">ホーム</Link>
            <Link to="/profile" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">自己紹介</Link>
            <Link to="/terms" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">注意事項</Link>
            <Link to="/faq" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">よくある質問</Link>
          </div>

          <button 
            onClick={() => window.location.href = '/#booking'}
            className="bg-[#FF9B8A] hover:bg-[#FF8A77] text-white px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            今すぐ予約
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#FFF5F3] via-white to-[#F0F9FF]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center">
            {/* Profile Info */}
            <div>
              <div className="inline-block px-4 py-2 bg-[#FF9B8A]/10 rounded-full mb-6">
                <span className="text-[#FF9B8A] text-sm font-medium">セラピスト紹介</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Klee One', cursive" }}>
                福井 萌日香
              </h1>
              
              <p className="text-xl text-gray-600 mb-8">
                ふくい もにか / 22歳
              </p>

              <div className="max-w-3xl mx-auto space-y-4 text-gray-700 leading-relaxed">
                <p className="text-base">
                  心理学を本気で勉強中の大学生です。ティーンエイジャーの皆さんが、もっと気軽に心と向き合える場所を作りたいと思っています。
                </p>
                <p className="text-base">
                  セラピーは特別なものじゃなく、毎日の歯磨きのように、自分の心をケアする時間。そんな風に感じてもらえたら嬉しいです。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Favorite Things Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-white to-[#FFF5F3]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-16" style={{ fontFamily: "'Klee One', cursive" }}>
            好きなこと
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Card 1 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 bg-[#FF9B8A]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-book-open-line text-3xl text-[#FF9B8A] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">本・詩を読むこと</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                言葉の持つ力に魅了されています。様々な視点や感情に触れることで、自分自身の理解も深まります。
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 bg-[#A8D5E2]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-brain-line text-3xl text-[#A8D5E2] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">心理学の勉強</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                人の心の仕組みを学ぶことは、自分や他者への理解を深める旅。毎日新しい発見があります。
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 bg-[#FFD93D]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-heart-3-line text-3xl text-[#FFD93D] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">犬を触ること</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                犬との触れ合いは心を癒してくれます。無条件の愛情と純粋さに、いつも元気をもらっています。
              </p>
            </div>

            {/* Card 4 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 bg-[#B4E197]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-walk-line text-3xl text-[#B4E197] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">散歩</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                歩きながら考えを整理したり、自然を感じたり。シンプルだけど、心がリセットされる大切な時間です。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-16" style={{ fontFamily: "'Klee One', cursive" }}>
            私だからできること
          </h2>

          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#FFD93D]/20 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-heart-pulse-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-2">食べること・体重への悩み</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  高校時代、食べすぎてしまう、食べられない、体重のことばかり考えてしまう日々がありました。その苦しさを経験したからこそ、同じ悩みを持つあなたの気持ちがわかります。
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#FFD93D]/20 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-refresh-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-2">繰り返す考えと行動</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  ひとつの考えが頭から離れない、安心するための行動が止められない。そんな自分を責めていた時期もありました。でも、それは決してあなたの弱さではありません。
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#FFD93D]/20 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-parent-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-2">親との関係</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  親に理解されない気持ち、毎日の小さな不安。誰にも言えない悩みを抱えていました。だからこそ、あなたの「小さな悩み」も大切に受け止めたいと思っています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Message Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-[#FFF5F3] to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" style={{ fontFamily: "'Klee One', cursive" }}>
            あなたへのメッセージ
          </h2>
          
          <div className="bg-white rounded-3xl p-12 shadow-xl">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              重たい悩みも、ちょっとした日常のモヤモヤも、全部大切なあなたの気持ちです。
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              セラピーは特別なものじゃなく、心の歯磨きのようなもの。健康な時はもっと自分を深く見つめられるように、何かで悩んでいる時はそこから少しでも楽になれるように。
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              大学生だからこそできる、目線が近い学生同士のアプローチで、あなたの心に寄り添います。
            </p>
            
            <button 
              onClick={() => window.location.href = '/#booking'}
              className="bg-[#FF9B8A] hover:bg-[#FF8A77] text-white px-10 py-4 rounded-full text-base font-medium transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              セッションを予約する
            </button>
          </div>
        </div>
      </section>

      {/* Why I Started Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12" style={{ fontFamily: "'Klee One', cursive" }}>
            このセラピーを始めた理由
          </h2>

          <div className="bg-gradient-to-br from-[#FFF5F3] via-white to-[#F0F9FF] rounded-3xl p-10 md:p-12 shadow-xl border border-[#FF9B8A]/10">
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-base md:text-lg">
                中学生から高校生の頃、私は摂食障害や体への悩み、自己肯定感の低さに苦しんでいました。
              </p>
              
              <p className="text-base md:text-lg">
                助けを求めたい。そう思って勇気を出して検索したとき、最初は優しく寄り添ってくれるカウンセラーさんに出会えたと思いました。でも、実際にカウンセリングを受けるには「10万円です」と言われたのです。
              </p>
              
              <p className="text-base md:text-lg">
                やっと救われると思ったのに。世の中ってこんなものなんだ。その悲しさは、今でも心のどこかに残っています。
              </p>
              
              <p className="text-base md:text-lg">
                それから時が経ち、私は全ての病気やコンプレックスを克服し、自分自身が自分の最高のサポーターになることができました。
              </p>
              
              <p className="text-base md:text-lg font-medium text-gray-900">
                だからこそ、あの時の自分が欲しかったもの、「これがあれば救われた」と思えるサービスを、私が始めようと決めました。
              </p>
              
              <p className="text-base md:text-lg">
                世界中の多くの国では、高校生にとってセラピーは歯磨きのように当たり前のこと。なのに日本では、まだまだ遠い存在です。
              </p>
              
              <p className="text-base md:text-lg font-medium text-[#FF9B8A]">
                どうか日本の若い子たちが、私のように苦しまず、第三者と話し、自分と向き合うことで癒しを見つけられますように。
              </p>
              
              <p className="text-base md:text-lg">
                そんな想いを込めて、このセラピーを提供しています。
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-gray-200 text-center">
              <p className="text-sm text-gray-600 italic">
                あなたの心に寄り添い、一緒に歩んでいけたら嬉しいです。
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
